import { render, staticRenderFns } from "./ActivityDescription.vue?vue&type=template&id=cb1fd16c&scoped=true"
import script from "./ActivityDescription.vue?vue&type=script&lang=js"
export * from "./ActivityDescription.vue?vue&type=script&lang=js"
import style0 from "./ActivityDescription.vue?vue&type=style&index=0&id=cb1fd16c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1fd16c",
  null
  
)

export default component.exports